import type { Novidade } from './tipos';

/**
 * Fase 2 (W20): registro com cadastro de uma empresa que a pessoa não vê (parceiros separados por empresa) aparece com o
 * rótulo neutro em Agenda, Conversas, Contratos, Contas e Compras; e o modo discreto passa a esconder os nomes no chat da
 * equipe. As imagens vêm da prova `scripts/provas/w20-parceiro-outra-empresa.ts` (`CAPTURAR=1`, modo discreto ligado).
 */
export const novidadeOutraEmpresa: Novidade = {
  id: '2026-10-05-outra-empresa',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Cadastro de outra empresa nas listas e nomes no chat no modo discreto',
      resumo: 'Registros da sua empresa com cliente de outra empresa não somem mais, e o modo discreto esconde os nomes no chat.',
      passos: [
        'Com os cadastros separados por empresa, o agendamento, a conversa, o contrato e a fatura da sua empresa aparecem e abrem normalmente.',
        'Quando o cliente ou fornecedor é de uma empresa que você não vê, o nome dá lugar a "Cadastro de outra empresa", sem link para a ficha.',
        'No chat da equipe, com o modo discreto e a opção de nomes, quem escreve, as menções, os participantes e os avisos aparecem só com as iniciais.',
      ],
    },
    en: {
      titulo: 'Records from another company in lists and names in chat in discreet mode',
      resumo: "Your company's records with a customer from another company no longer disappear, and discreet mode hides names in chat.",
      passos: [
        "With records split by company, your company's appointments, conversations, contracts and invoices show up and open as usual.",
        'When the customer or supplier belongs to a company you cannot see, the name becomes "Record from another company", with no link to the record.',
        'In team chat, with discreet mode and the names option on, authors, mentions, members and alerts show only initials.',
      ],
    },
    es: {
      titulo: 'Registro de otra empresa en las listas y nombres en el chat en modo discreto',
      resumo: 'Los registros de tu empresa con un cliente de otra empresa ya no desaparecen, y el modo discreto oculta los nombres en el chat.',
      passos: [
        'Con los registros separados por empresa, la cita, la conversación, el contrato y la factura de tu empresa aparecen y se abren como siempre.',
        'Cuando el cliente o proveedor es de una empresa que no ves, el nombre se reemplaza por "Registro de otra empresa", sin enlace a la ficha.',
        'En el chat del equipo, con el modo discreto y la opción de nombres, quien escribe, las menciones, los participantes y los avisos muestran solo las iniciales.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-outra-empresa/conversa.webp', null, '/novidades/2026-10-05-outra-empresa/chat.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/comercial/conversas/whatsapp',
};
